enum events {
  IMAGE_EDITOR_OPEN = 'image_editor--editor--open',
  IMAGE_EDITOR_COMPLETED = 'image_editor--editor--completed',
}

export default events